var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col col-12" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: { readonly: "" },
          domProps: { value: _vm.valueMutable }
        })
      ]),
      _c("div", { staticClass: "col-md-2 mt-1" }, [
        _c("div", { staticClass: "btn-group" }, [
          _vm.hasPermisionSave
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip",
                      value: "Abrir editor visual",
                      expression: "'Abrir editor visual'"
                    }
                  ],
                  staticClass: "btn btn-outline-secondary",
                  on: { click: _vm.openEditor }
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("edit")
                  ])
                ]
              )
            : _vm._e()
        ])
      ]),
      _c(
        "b-modal",
        {
          ref: "modaleditar",
          attrs: {
            title: "Editor de plantilla de firma",
            size: "xl",
            "hide-footer": ""
          }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-7" },
              [
                _c("StampTemplateEditor", {
                  model: {
                    value: _vm.valueMutable,
                    callback: function($$v) {
                      _vm.valueMutable = $$v
                    },
                    expression: "valueMutable"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "col-md-5" }, [
              _c(
                "div",
                { staticClass: "sticky-top", staticStyle: { top: "10px" } },
                [
                  _c("StampPreviewCanvas", {
                    attrs: {
                      template: _vm.valueMutable,
                      userData: _vm.dummyUserData,
                      companyData: _vm.dummyCompanyData
                    },
                    on: {
                      "update-position": _vm.onPositionUpdate,
                      "update-size": _vm.onSizeUpdate
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }